"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emojiUrl = exports.parseEmojiCategories = void 0;
/**
 * Composes a URL to an emoji.
 * @param code A code that can be found in the emoji manifest.
 */
function emojiUrl(code) {
  return "https://padlet.net/icons/png/" + code + ".png";
}
exports.emojiUrl = emojiUrl;
/**
 * Parses a list of categories of emojis.
 */
function parseEmojiCategories(categories) {
  return categories.map(function (c) {
    return {
      label: c
    };
  });
}
exports.parseEmojiCategories = parseEmojiCategories;